import * as React from 'react'
// views
import { CheckedIcon, OptionTitle, OptionWrapper } from '../view'
// components
import ControlButtons from './components/ControlButtons'

// types
interface Props {
  onClick: () => void
  isActive: boolean
  canManage: boolean
  dashboard: Record<string, any>
  closePopup: () => void
  onDashboardEditDone: (id: string) => void
}

export const DashboardOption: React.FC<Props> = ({
  onClick,
  dashboard,
  isActive,
  canManage,
  closePopup,
  onDashboardEditDone
}) => {
  return (
    <OptionWrapper isActive={isActive} onClick={onClick}>
      {canManage && (
        <ControlButtons closePopup={closePopup} dashboard={dashboard} onDashboardEditDone={onDashboardEditDone} />
      )}
      <OptionTitle>
        <p>{dashboard.title}</p>
        {isActive && <CheckedIcon />}
      </OptionTitle>
      <p>{dashboard.description}</p>
    </OptionWrapper>
  )
}

export default DashboardOption
